<template>
  <div class="revitBanbenshezhi">
    <el-button v-if="releasePlann" :disabled="disabled1" type="primary" size="small" @click="releaseplan">
      发布策划
    </el-button>
    <img v-if="releasePlann" :src="tanhao" class="tanhao" />
    <span v-if="releasePlann" class="titletipe">提示：版本只能发布一次</span>
    <div class="content">
      <el-radio-group v-model="radio" :disabled="disabled1">
        <el-radio v-for="(item, index) in RevitVersionList" :key="index" :label="item.revitId" class="radioStyle">
          {{ item.revitNameOrVersion }}
        </el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import requestprj from "@/CommonDP/service/standardPlan-service";
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
export default {
  name: "RevitBanbenshezhi",
  data() {
    return {

      radio: "",
      prjID: "",
      disabled1: false,
      RevitVersionList: [],
      tanhao: require("@/CommonDP/assets/settings/tanhao.png")
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj
    }),
    releasePlann() {
      return checkPermission(this.$allPerms.SETUP_RELEASEPLANN);
    }
  },
  watch: {
    prjInfo: {
      deep: true,
      handler: function ({ prjId }, oldValue) {
        if (prjId) {
          this.prjID = this.prjInfo.prjId;
          this.queryPrjRevitVersion();
        }
      }
    }
  },
  created() {
    this.prjID = this.prjInfo.prjId;
    if (this.prjID) {
      this.queryPrjRevitVersion();
    }
    this.getSysRevitVersionList();
  },
  methods: {
    // 设置 Revit版本
    releaseplan() {
      if (this.radio) {
        requestprj.setPrjRevitVersion(this.prjID, this.radio).then((res) => {
          if (res.result === "0") {
            this.$message({
              message: "设置成功",
              type: "success"
            });
            this.queryPrjRevitVersion();
          }
        });
      } else {
        this.$message({
          message: "请选择Revit版本",
          type: "warning"
        });
      }
    },
    // 判断Revit版本是否设置过
    queryPrjRevitVersion() {
      requestprj.getPrjRevitVersion(this.prjID).then((res) => {
        if (res.result === "0") {
          if (res.data) {
            this.radio = res.data.revitId;
            this.disabled1 = true;
          } else {
            this.disabled1 = false;
          }
        }
      });
    },
    // 查询 所有Revit版本list数据
    getSysRevitVersionList() {
      requestprj.getSysRevitVersionList().then((res) => {
        if (res.result === "0") {
          if (res.data) {
            this.RevitVersionList = res.data;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.revitBanbenshezhi {
  width: 100%;
  height: 100%;
  .tanhao {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-left: 28px;
  }
  .titletipe {
    color: #ef4545;
    font-size: 14px;
    margin-left: 5px;
  }
  .content {
    margin-top: 41px;
  }
  .radioStyle {
    margin-right: 124px;
    margin-bottom: 20px;
    font-size: 14px;
  }
}
</style>
